export default {
	name: 'stripes',
	label: 'Stripes',
	description: 'Bands across a surface or round its outline — straight, wavy or zigzag, with perspective',

	expose: {
		speed: {
			tip: 'How fast the bands travel, across or out to the outline; negative reverses',
			step: 0.01,
			period: 0.24,
			initial: 1,
			minimum: -8,
			maximum: 8,
		},
		zoom: {
			tip: 'Zooms the whole pattern',
			minimum: 0.25,
			maximum: 4,
		},
		angle: {
			tip: 'Direction of the stripes and their travel; round the outline, where the waves start',
			initial: 0,
		},
		tilt: {
			tip: 'Straight down at 90; lower tips the surface away, crowding the far bands',
			initial: 90,
		},
		width: {
			tip: 'Thickness of each band',
			initial: 8,
			minimum: 0.25,
			maximum: 50,
			step: 0.05,
		},
		spacing: {
			tip: 'See-through gap between bands',
			initial: 0,
			minimum: 0,
			maximum: 50,
			step: 0.05,
		},
		grow: {
			tip: 'Bands widen as they travel (narrow behind) above 0, narrow below it; the gaps hold',
			initial: 0,
		},
		enclose: {
			tip: 'Straight across at 0; the bands bend round the outline into rings at 1',
			initial: 0,
			step: 0.01,
		},
		fold: {
			tip: 'Bands from one side at 0; from both sides, meeting on the centre line, at 1',
			initial: 0,
			step: 0.01,
		},
		fit: {
			tip: 'Rings as squares or circles about the centre at 0; following the outline at 1',
			initial: 1,
			step: 0.01,
		},
		rounding: {
			tip: 'Sharp rings at 0; round at 1: circles, or the outline rounded about its core',
			initial: 0,
		},
		wave_height: {
			tip: 'How far the bands swing; 0 is straight',
			initial: 0,
			maximum: 100,
		},
		wave_length: {
			tip: 'Length of each wave along the bands; round the outline, the nearest whole count',
			initial: 200,
			minimum: 16,
			maximum: 2000,
		},
		shape: {
			tip: 'Round waves at 0, zigzag at 1',
			initial: 0,
			minimum: 0,
			maximum: 1,
			step: 0.01,
		},
		color: {
			tip: 'First palette colour',
			initial: '#33d6ff',
		},
		color_b: {
			label: 'Color 2',
			tip: 'Last palette colour',
			initial: '#2a1a7a',
		},
		spread: {
			tip: 'Number of colours from Color to Color 2',
			initial: 2,
		},
		repeat: {
			tip: 'Ramp restarts the palette, Mirror walks back',
			initial: 0,
		},
		wash: {
			tip: 'Scrolls the palette through the bands, colours per second',
			initial: 0,
			period: 1,
		},
		ground: {
			tip: 'Between and behind the bands: its colour and opacity',
			initial: '#00000000',
		},
	},
	range: { tunnel: [0, 1], pan: [-1000, 1000] },
}
